import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "time",
})
export class TimePipe implements PipeTransform {
  transform(value: number, ...args: unknown[]): string {
    const minutes = parseInt((value / 60).toString());
    const seconds = value % 60;
    return `${minutes ? minutes + ` minute${minutes > 1 ? "s" : ""} ` : ""}${
      seconds ? seconds + ` second${seconds > 1 ? "s" : ""} ` : ""
    }`;
  }
}
